"use strict";

require("core-js/modules/es.weak-map.js");
require("core-js/modules/web.dom-collections.iterator.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _paulCorePackage = require("paul-core-package");
var _TemperatureWidget = require("../../components/TemperatureCardsWidget/TemperatureWidget");
var _constants = require("../../utils/constants");
var _reducers = require("../../redux/reducers");
var _sagas = _interopRequireDefault(require("../../redux/sagas"));
var _reactRedux = require("react-redux");
var _actions = require("../../redux/actions");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
/**
 * TemperatureWidget
 * @return {JSX.Element}
 * @constructor
 */

const TemperatureWidgetInitial = () => {
  const dispatch = (0, _reactRedux.useDispatch)();
  const firstEffect = (0, _react.useRef)(true);
  const coreDevices = (0, _reactRedux.useSelector)(store => {
    var _store$constants$pack;
    return ((_store$constants$pack = store[_paulCorePackage.constants.packageKey]) === null || _store$constants$pack === void 0 ? void 0 : _store$constants$pack.devices) || {};
  });
  (0, _react.useEffect)(() => {
    if (firstEffect.current && coreDevices !== null && coreDevices !== void 0 && coreDevices.hasData) {
      firstEffect.current = false;
      dispatch((0, _actions.setInitialDeviceData)({
        result: coreDevices
      }));
    }
  }, [dispatch, coreDevices]);
  (0, _react.useEffect)(() => {
    return () => {
      firstEffect.current = true;
      dispatch((0, _actions.resetAll)());
    };
  }, [dispatch]);
  return /*#__PURE__*/_react.default.createElement(_TemperatureWidget.TemperatureWidget, null);
};
const TemperatureWidgetConnect = () => {
  (0, _paulCorePackage.useInjectStore)({
    key: _constants.packageKey,
    reducer: {
      reducers: _reducers.reducers
    },
    saga: _sagas.default
  });
  return /*#__PURE__*/_react.default.createElement(TemperatureWidgetInitial, null);
};
var _default = exports.default = TemperatureWidgetConnect;